// const breakPointSm  = 481;
const breakPointMd = 768;
const breakPointLg = 1024;
// const breakPointXl  = 1200;
let windowWidth  = window.innerWidth;
let windowHeight = window.innerHeight;
let windowScrollPos = 0;



function _vwSP(size, base = 768) {
  windowWidth = window.innerWidth;
  return (size / base) * windowWidth;
}

function _vwPC(size, base = 1920) {
  windowWidth = window.innerWidth;
  return (size / base) * windowWidth;
}



// ------------------------------------------------------------------------
// 【共通】スムーススクロール
// ------------------------------------------------------------------------
const anchorLink = () => {
  $('a.scroll[href^="#"]').on('click', function() {
    let linkSpeed    = 400;
    let linkHref     = $(this).attr('href');
    let linkTarget   = $(linkHref == '#' || linkHref == '' ? 'html' : linkHref);
    let linkPosition = linkTarget.offset().top;
    let linkAdjust   = 0;
    $('html, body').animate({scrollTop: linkPosition - linkAdjust}, linkSpeed, 'swing');
    return false;
  });
};



// ------------------------------------------------------------------------
// 【共通】ページトップの表示・非表示
// ------------------------------------------------------------------------
const pageTop = () => {
  let scrollHeight;
  let scrollPos;
  let footerHeight;
  let footerHeightAdjust;

  $(window).on('load scroll', function() {
    if( $(this).scrollTop() > 300 ) {
      $('.st-PageTop').fadeIn();
    } else {
      $('.st-PageTop').fadeOut();
    }

    scrollHeight = $(document).height();
    scrollPos = $(window).height() + $(window).scrollTop();
    if( windowWidth < breakPointLg ) {
      footerHeightAdjust = _vwSP(40) + _vwSP(30); //PageTopボタンのFooter停止位置＋fixed時のBottom値
    } else {
      footerHeightAdjust = _vwPC(30) + _vwPC(30); //PageTopボタンのFooter停止位置＋fixed時のBottom値
    }
    footerHeight = $('footer').innerHeight() - footerHeightAdjust;

    if( scrollHeight - scrollPos <= footerHeight ) {
      $('.st-PageTop').removeClass('fixed');
    } else {
      $('.st-PageTop').addClass('fixed');
    }
  });
}



// ------------------------------------------------------------------------
// 【共通】ヘッダー　ハンバーガーメニュー表示・非表示
// ------------------------------------------------------------------------
const headerMenuToggle = () => {
  $('.st-Header_MenuBtn').on('click', function() {
    if( !$(this).hasClass('opened') ) {
      $('.st-Header_MenuBtn').addClass('opening');
      $('.st-Header_Menu').addClass('opening');

      $('.st-Header_Nav_Wrapper').addClass('opened');
      $('.st-Header_Nav_Container').addClass('opened');

      //メニューの高さ計算
      let headerHeight, navHeight;
      if( windowWidth < breakPointMd ) {
        headerHeight = _vwSP(114);
      } else if( windowWidth >= breakPointMd && windowWidth < breakPointLg ) {
        headerHeight = 114;
      } else {
        headerHeight = _vwPC(90);
      }
      navHeight = $(window).height() - headerHeight;
      $('.st-Header_Nav').addClass('opened').css({'height': navHeight});


      setTimeout(function() {
        $('.st-Header_MenuBtn').addClass('opened');
        $('.st-Header_Menu').addClass('opened');
      }, 100);
      setTimeout(function() {
        $('.st-Header_MenuBtn').removeClass('opening');
        $('.st-Header_Menu').removeClass('opening');
      }, 1100);

    } else {
      $('.st-Header_MenuBtn').addClass('closing').removeClass('opened');

      $('.st-Header_Nav_Wrapper').removeClass('opened');
      $('.st-Header_Nav_Container').removeClass('opened');
      $('.st-Header_Nav').removeClass('opened').css({'height': ''});
      $('.st-Header_Menu').removeClass('opened');

      setTimeout(function() {
        $('.st-Header_MenuBtn').removeClass('closing');
      }, 500);
    }
  });


  $('.menu_item').on('click', function() {
    let linkSpeed    = 400;
    let linkHref     = $(this).attr('href');
    let linkTarget   = $(linkHref == '#' || linkHref == '' ? 'html' : linkHref);
    let linkPosition = linkTarget.offset().top;
    let linkAdjust   = 0;

    if( windowWidth < breakPointMd ) {
      linkAdjust = _vwSP(160);
    } else if( windowWidth >= breakPointMd && windowWidth < breakPointLg ) {
      linkAdjust = 160;
    } else {
      linkAdjust = _vwPC(180);
    }

    $('html, body').animate({scrollTop: linkPosition - linkAdjust}, linkSpeed, 'swing');


    $('.st-Header_MenuBtn').addClass('closing').removeClass('opened');

    $('.st-Header_Nav_Wrapper').removeClass('opened');
    $('.st-Header_Nav_Container').removeClass('opened');
    $('.st-Header_Nav').removeClass('opened').css({'height': ''});
    $('.st-Header_Menu').removeClass('opened');

    setTimeout(function() {
      $('.st-Header_MenuBtn').removeClass('closing');
    }, 500);

    return false;
  });


  $(window).on('load', function() {
    let hash = location.hash;

    if( hash ) {
      let linkPosition = $(hash).offset().top;
      let linkAdjust   = 0;

      if( windowWidth < breakPointMd ) {
        linkAdjust = _vwSP(160);
      } else if( windowWidth >= breakPointMd && windowWidth < breakPointLg ) {
        linkAdjust = 160;
      } else {
        linkAdjust = _vwPC(180);
      }

      $('html, body').animate({scrollTop: linkPosition - linkAdjust}, 0);
    }
  });
}



// ------------------------------------------------------------------------
// 【共通】PCのスクロール時にロゴ縮小
// ------------------------------------------------------------------------
const pcHeaderLogo = () => {
  $(window).on('load scroll resize', function() {
    if( windowWidth >= breakPointLg ) {
      if( $(this).scrollTop() > 300 ) {
        $('.st-Header_Logo').addClass('shrink');
      } else {
        $('.st-Header_Logo').removeClass('shrink');
      }
    }
  });
}



// ------------------------------------------------------------------------
// 【Index】スクロールアニメーション
// ------------------------------------------------------------------------
const idxScrollAnimation = () => {
  function titleBgShow(target) {
    let targetElem = $(target);
    let targetBgWidth = $(target).find('.bg').width();

    targetElem.css({'width': targetBgWidth});

    setTimeout(function() {
      targetElem.css({'width': 'auto'});
    }, 600);
  }

  function musicShowAnimation(parentElem) {
    titleBgShow(parentElem.find('.bg_hidden'));
    parentElem.find('.bg_hidden').addClass('js-animated');
    parentElem.find('.ttl').addClass('js-fadeup_animated');
    parentElem.find('.music_jacket').addClass('js-fadeup_animated');
    parentElem.find('.music_release').addClass('js-fadeup_animated');
    parentElem.find('.music_body').addClass('js-animated');
  }

  function costumeShowAnimation(parentElem) {
    titleBgShow(parentElem.find('.costume_haeding .bg_hidden'));
    parentElem.find('.bg_hidden').addClass('js-animated');
    parentElem.find('.logo').addClass('js-fadeup_animated');
    parentElem.find('.costume_chara').addClass('js-fadeup_animated');
    parentElem.find('.costume_body').addClass('js-animated');
  }

  function kvImageScroll(scrollPos) {
    let roseliaImg = $('.idx-KeyVisual_Img.roselia .chara');
    let morfonicaImg = $('.idx-KeyVisual_Img.morfonica .chara');
    let rasImg = $('.idx-KeyVisual_Img.ras .chara');
    let imgPos = 0;

    imgPos = scrollPos * 0.05;
    if( imgPos > 60 ) {
      imgPos = 60;
    }

    roseliaImg.css({'transform': 'translateY(' + imgPos + 'px)'});
    morfonicaImg.css({'transform': 'translateY(' + imgPos + 'px)'});
    rasImg.css({'transform': 'translateY(' + imgPos + 'px)'});
  }



  //スクロールアニメーション
  function scrollAnime() {
    let controller = new ScrollMagic.Controller();
    let sceneKvNotice;
    let sceneAboutRoselia, sceneAboutMorfonica, sceneAboutRas;
    let sceneCostumeRoselia, sceneCostumeMorfonica, sceneCostumeRas;
    let aboutOffset_01 = 0, aboutOffset_02 = 0, costumeOffset_01 = 0, costumeOffset_02 = 0;

    if( windowWidth < breakPointMd ) {
      aboutOffset_01 = _vwSP(-360);
      aboutOffset_02 = _vwSP(-600);
      costumeOffset_01 = _vwSP(-360);
      costumeOffset_02 = _vwSP(-480);
    } else if( windowWidth >= breakPointMd && windowWidth < breakPointLg ) {
      aboutOffset_01 = _vwSP(-360);
      aboutOffset_02 = _vwSP(-480);
      costumeOffset_01 = _vwSP(-300);
      costumeOffset_02 = _vwSP(-360);
    } else {
      aboutOffset_01 = _vwPC(-640);
      aboutOffset_02 = _vwPC(-600);
      costumeOffset_01 = _vwPC(-540);
      costumeOffset_02 = _vwPC(-400);
    }

    sceneKvNotice = new ScrollMagic.Scene({
      triggerElement: '#keyvisual',
      triggerHook: 'onCenter',
      reverse: false,
      offset: 0
    })
    .on('enter', function() {
      $('.notice_left .bg_flash').addClass('js-animated');
      $('.notice_right .bg_flash').addClass('js-animated');
      $('.notice_left .txt').addClass('js-fadeup_animated');
      $('.notice_right .txt').addClass('js-fadeup_animated');
      titleBgShow($('.notice_left .bg_hidden'));
      titleBgShow($('.notice_right .bg_hidden'));
    })
    // .addIndicators()
    .addTo(controller);


    sceneAboutRoselia = new ScrollMagic.Scene({
      triggerElement: '#about_roselia',
      triggerHook: 'onCenter',
      reverse: false,
      offset: aboutOffset_01
    })
    .on('enter', function() {
      musicShowAnimation($('#about_roselia'));
    })
    // .addIndicators()
    .addTo(controller);


    sceneAboutMorfonica = new ScrollMagic.Scene({
      triggerElement: '#about_morfonica',
      triggerHook: 'onCenter',
      reverse: false,
      offset: aboutOffset_02
    })
    .on('enter', function() {
      musicShowAnimation($('#about_morfonica'));
    })
    // .addIndicators()
    .addTo(controller);


    sceneAboutRas = new ScrollMagic.Scene({
      triggerElement: '#about_ras',
      triggerHook: 'onCenter',
      reverse: false,
      offset: aboutOffset_02
    })
    .on('enter', function() {
      musicShowAnimation($('#about_ras'));
    })
    // .addIndicators()
    .addTo(controller);


    sceneCostumeRoselia = new ScrollMagic.Scene({
      triggerElement: '#costume_roselia',
      triggerHook: 'onCenter',
      reverse: false,
      offset: costumeOffset_01
    })
    .on('enter', function() {
      costumeShowAnimation($('#costume_roselia'));
    })
    // .addIndicators()
    .addTo(controller);


    sceneCostumeMorfonica = new ScrollMagic.Scene({
      triggerElement: '#costume_morfonica',
      triggerHook: 'onCenter',
      reverse: false,
      offset: costumeOffset_02
    })
    .on('enter', function() {
      costumeShowAnimation($('#costume_morfonica'));
    })
    // .addIndicators()
    .addTo(controller);


    sceneCostumeRas = new ScrollMagic.Scene({
      triggerElement: '#costume_ras',
      triggerHook: 'onCenter',
      reverse: false,
      offset: costumeOffset_02
    })
    .on('enter', function() {
      costumeShowAnimation($('#costume_ras'));
    })
    // .addIndicators()
    .addTo(controller);
  }


  function contentScrollAnim(scrollPos) {
    $('.js-scroll_target').each(function() {
      let targetElem = $(this);
      let targetElemOffset = $(this).offset().top;

      if( windowWidth < breakPointMd ) {
        //
      } else if( windowWidth >= breakPointMd && windowWidth < breakPointLg ) {
        targetElemOffset += _vwSP(100);
      } else {
        targetElemOffset += _vwPC(100);
      }

      if( windowScrollPos + windowHeight > targetElemOffset ) {
        targetElem.addClass('js-fadeup_animated');
      }
    });
  }


  //スクロールアニメーション
  $(window).on('load scroll', function() {
    windowScrollPos = $(window).scrollTop();
    kvImageScroll(windowScrollPos);
    contentScrollAnim(windowScrollPos);
  });

  scrollAnime();
}



// ------------------------------------------------------------------------
// 【Index】Encore　モーダル
// ------------------------------------------------------------------------
const idxEncoreModal = () => {
  $('.idx-Encore_Costume_Container .modal_target').on('click', function() {
    let target = $(this).attr('data-target');

    $('.idx-Encore_Modal_Wrapper .modal_box.' + target).css({'display': 'block'});
    $('.idx-Encore_Modal_Wrapper').fadeIn(300);

    return false;
  });


  $('.idx-Encore_Modal_Wrapper .btn_close').on('click', function() {
    $('.idx-Encore_Modal_Wrapper').fadeOut(200);

    setTimeout(function() {
      $('.idx-Encore_Modal_Wrapper .modal_box').css({'display': ''});
    }, 200);

    return false;
  });
}



const idxTweetBox = () => {
  $(window).on('load', function() {
    setTimeout(function() {
      $('.idx-Campaign_Tweet .tweet_box').removeClass('loading');
      $('.idx-Campaign_Tweet .btn_retweet').removeClass('loading');
    }, 1000);


    let nowDate = new Date();
    nowDate = Math.floor(nowDate / 1000);

    $('.idx-Campaign_Tweet .tweet_item').each(function() {
      let endDate = $(this).attr('data-end-date');

      if( nowDate >= endDate ) {
        $(this).addClass('end');
      }
    });
  });
}



// ------------------------------------------------------------------------
// 【MV】スクロールアニメーション
// ------------------------------------------------------------------------
const mvScrollAnimation = () => {
  function contentScrollAnim(scrollPos) {
    $('.js-scroll_target').each(function() {
      let targetElem = $(this);
      let targetElemOffset = $(this).offset().top;

      if( windowWidth < breakPointMd ) {
        //
      } else if( windowWidth >= breakPointMd && windowWidth < breakPointLg ) {
        targetElemOffset += _vwSP(100);
      } else {
        targetElemOffset += _vwPC(100);
      }

      if( windowScrollPos + windowHeight > targetElemOffset ) {
        targetElem.addClass('js-fadeup_animated');
      }
    });
  }


  //スクロールアニメーション
  $(window).on('load scroll', function() {
    windowScrollPos = $(window).scrollTop();
    contentScrollAnim(windowScrollPos);
  });
}



export {
  anchorLink,
  pageTop,
  headerMenuToggle,
  pcHeaderLogo,
  idxScrollAnimation,
  idxEncoreModal,
  idxTweetBox,
  mvScrollAnimation,
}



// WEBPACK FOOTER //
// ./src/assets/js/include/module.js